/*
 * @Description: 日程管理 - 日程API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取日程列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getScheduleList(params) {
  return request({
    url: '/schedule/item/list',
    method: 'get',
    params
  })
}

/**
 * 获取日程矩阵视图
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getScheduleMatrix(params) {
  return request({
    url: '/schedule/matrix',
    method: 'get',
    params
  })
}

/**
 * 获取日程详情
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function getScheduleDetail(data) {
  return request({
    url: '/schedule/item/detail',
    method: 'post',
    data
  })
}

/**
 * 添加日程
 * @param {Object} data - 日程数据
 * @returns {Promise}
 */
export function addSchedule(data) {
  return request({
    url: '/schedule/item/add',
    method: 'post',
    data
  })
}

/**
 * 更新日程
 * @param {Object} data - 日程数据
 * @returns {Promise}
 */
export function updateSchedule(data) {
  return request({
    url: '/schedule/item/edit',
    method: 'post',
    data
  })
}

/**
 * 删除日程
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteSchedule(data) {
  return request({
    url: '/schedule/item/delete',
    method: 'post',
    data
  })
}

/**
 * 批量删除日程
 * @param {Object} data - 包含ids数组的参数对象
 * @returns {Promise}
 */
export function batchDeleteSchedule(data) {
  return request({
    url: '/schedule/item/batchDelete',
    method: 'post',
    data
  })
}

/**
 * 检查时间冲突
 * @param {Object} data - 日程数据
 * @returns {Promise}
 */
export function checkTimeConflict(data) {
  return request({
    url: '/schedule/item/checkConflict',
    method: 'post',
    data
  })
} 